// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f34ce93e","758":"a944fd8b","827":"a270be2d"}[chunkId] + ".chunk.js";
};